import { render, staticRenderFns } from "./zlNewPay.vue?vue&type=template&id=41e22060&scoped=true&"
var script = {}
import style0 from "./zlNewPay.vue?vue&type=style&index=0&id=41e22060&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e22060",
  null
  
)

export default component.exports